import { createSelector } from 'reselect'
import { LOGISTIC, PRICES, ROUTES,USERS, BOOK, WEBSITE_BOOKINGS } from 'constants/urls'

const getState = state => state.router
const currentPathname = state => getState(state).location.pathname

const isLogisticPageSelector = createSelector(
  currentPathname,
  pathname => pathname === LOGISTIC
)

const isBookPageSelector = createSelector(
  currentPathname,
  pathname => pathname === BOOK
)

const isPricesPageSelector = createSelector(
  currentPathname,
  pathname => pathname === PRICES
)

const isRoutesPageSelector = createSelector(
  currentPathname,
  pathname => pathname === ROUTES
)

const isUsersPageSelector = createSelector(
  currentPathname,
  pathname => pathname === USERS
)

const isWebsiteBookingsPageSelector = createSelector(
  currentPathname,
  pathname => pathname === WEBSITE_BOOKINGS
)

export {
  isWebsiteBookingsPageSelector,
  isLogisticPageSelector,
  isPricesPageSelector,
  isRoutesPageSelector,
  isUsersPageSelector,
  isBookPageSelector,
}



// WEBPACK FOOTER //
// ./src/reduxModules/selectors/RouterSelectors.js